<template>
	<span class="k-svg-icon" v-html="sanitizedSvg" />
</template>

<script>
import DOMPurify from 'dompurify'

export default {
	name: 'SvgIconComponent',

	props: {
		svgContent: { type: String, required: true }
	},

	computed: {
		sanitizedSvg() {
			const clean = DOMPurify.sanitize(this.svgContent, { USE_PROFILES: { svg: true } })
			return this.stripFullSizeBackgroundRect(clean)
		}
	},

	methods: {
		// Design tools (Figma, Illustrator) often export SVGs with a full-size <rect> as a
		// background layer. When placed last in the document, it renders on top of all icon
		// paths and hides them. Strip any rect that covers the entire viewBox.
		stripFullSizeBackgroundRect(svgString) {
			try {
				const parser = new DOMParser()
				const doc = parser.parseFromString(svgString, 'image/svg+xml')
				const svg = doc.documentElement
				if (svg.tagName === 'parseerror') return svgString

				const vbParts = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number)
				if (vbParts.length < 4 || vbParts.some(isNaN)) return svgString
				const [, , vbW, vbH] = vbParts

				for (const rect of svg.querySelectorAll('rect')) {
					const x = parseFloat(rect.getAttribute('x') || '0')
					const y = parseFloat(rect.getAttribute('y') || '0')
					const w = rect.getAttribute('width')
					const h = rect.getAttribute('height')
					const isFullWidth = w === '100%' || parseFloat(w) === vbW
					const isFullHeight = h === '100%' || parseFloat(h) === vbH
					if (x === 0 && y === 0 && isFullWidth && isFullHeight) rect.remove()
				}

				return new XMLSerializer().serializeToString(svg)
			} catch {
				return svgString
			}
		}
	}
}
</script>

<style>
.k-svg-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.k-svg-icon svg {
	fill: currentColor;
	width: 1em;
	height: 1em;
}
</style>
